module.exports = __webpack_public_path__ + "static/media/video-camera-chat.b040a761.svg";